$("#search-reference").on("click", function(){
  $.ajax({
    type: "GET",
    url: "http://localhost:3000/reference?id=" + $("#search-input").val(),
    dataType: "json",
    success: function(result){
      if (result.length === 0) {
        return;
      } else {
        let reference = result[0]
        $("#reference-id").text(reference.id);
        $("#reference-name").text(reference.name);
      }
    },
    error: function(result) {
      alert("関連ID情報の取得に失敗しました。");
    }
  });
});
